import React from 'react';

class ProfessionalSkills extends React.Component {
  render() {
    return (
      <section id="skills-section" className="skills-section section text-center">
        <h2 className="section-title">Professional Skills</h2>
        <div className="top-skills">
          <h3 className="subtitle">Top Skills</h3>
          <div className="row">
            <div className="item col-xs-12 col-sm-4">
              <div className="item-inner">
                <h4 className="skill-name">JavaScript/NodeJs</h4>
                <div className="level">Expert, 10 years</div>
                <div className="desc">
                  Javascript, NodeJS, ES6, Typescript, ExpressJS, GraphQL,
                  Socket.IO, Webpack, Gulp, Grunt, MongoDB, Postgres, Redis etc.
                </div>
              </div>
            </div>
            <div className="item col-xs-12 col-sm-4">
              <div className="item-inner">
                <h4 className="skill-name">ASP.NET MVC &amp; C#</h4>
                <div className="level">Expert, 13 years</div>
                <div className="desc">
                  ASP.NET, .NET Core, C#, .NET Framework, LINQ, IIS, MS SQL Server, etc.
                </div>
              </div>
            </div>
            <div className="item col-xs-12 col-sm-4">
              <div className="item-inner">
                <h4 className="skill-name">ReactJS &amp; VueJS</h4>
                <div className="level">Advanced, 7 years</div>
                <div className="desc">
                  ReactJS, VueJS, React-Native, etc.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="other-skills">
          <h3 className="subtitle">Other Skills</h3>
          <div className="misc-skills">
            <span className="skill-tag">HTML5</span>
            <span className="skill-tag">CSS3</span>
            <span className="skill-tag">SASS</span>
            <span className="skill-tag">LESS</span>
            <span className="skill-tag">Git</span>
            <br />
            <span className="skill-tag">Docker</span>
            <span className="skill-tag">Swarm</span>
            <span className="skill-tag">AWS</span>
            <span className="skill-tag">Azure</span>
            <span className="skill-tag">Digital Ocean</span>
          </div>
        </div>
      </section>
    );
  }
}

ProfessionalSkills.propTypes = {
  route: React.PropTypes.object,
};

export default ProfessionalSkills;



// WEBPACK FOOTER //
// ../components/Blocks/ProfessionalSkills.jsx